/*
 * @format
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ContentContainerBodyShift } from '../../sharedComponents/LayoutHelpers';
import { FlexCol, FlexRow } from '../../sharedComponents/FlexGrid';
import HelmetWrapper from '../../sharedComponents/HelmetWrapper';
import HeroImageCombined from '../../sharedComponents/HeroImageCombined';
import RightRail from './RightRail';
import TabItems from './TabItems';
import ErrorNotification from './ErrorNotification';
import BreadcrumbsContainer from './BreadcrumbsContainer';
import FacilityPageHeader from './FacilityPageHeader';

export default class VenuePage extends React.Component {
    static propTypes = {
        map: PropTypes.node,
        errors: PropTypes.arrayOf(PropTypes.string),
        errorRef: PropTypes.shape({
            current: PropTypes.instanceOf(Element)
        }),
        title: PropTypes.string.isRequired,
        rightRail: PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.node,
            links: PropTypes.arrayOf(
                PropTypes.shape({
                    url: PropTypes.string,
                    title: PropTypes.string,
                    description: PropTypes.string
                })
            ),
            notAuth: PropTypes.bool
        }),
        assetId: PropTypes.string,
        inventoryType: PropTypes.oneOf(['Camping', 'DayUse', 'HuntingPermit', 'Lottery', 'POI', 'Pass', 'Permit', 'RecArea', 'Rental', 'Ticket', 'VehiclePermit']),
        activities: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
        breadcrumbPath: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                url: PropTypes.string
            })
        ),
        partOf: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string
        }),
        starRating: PropTypes.node,
        cellRating: PropTypes.node,
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                content: PropTypes.node
            })
        ),
        activeTabIndex: PropTypes.number,
        onActiveTabIndexChange: PropTypes.func,
        isLoading: PropTypes.bool,
    };

    static defaultProps = {
        activities: [],
        breadcrumbPath: []
    };

    render() {
        const {
            title,
            rightRail,
            assetId,
            inventoryType,
            breadcrumbPath,
            partOf,
            starRating,
            cellRating,
            map,
            errors,
            errorRef,
            tabs,
            activeTabIndex,
            onActiveTabIndexChange,
            activities,
            isLoading,
        } = this.props;

        return (
            <div className="rec-page rec-venue-page">
                <div id="page-body">
                    <HelmetWrapper title={title} />
                    {assetId && <HeroImageCombined type="asset" id={assetId} loadingType='placeholder'/>}
                    <ContentContainerBodyShift>
                        <FlexRow>
                            {/* Left Rail */}
                            <FlexCol lg={8} className="rec-venue-page-left-rail">
                                {/* Breadcrumbs and the main title of this page */}
                                <BreadcrumbsContainer path={breadcrumbPath} isLoading={isLoading} />

                                <ErrorNotification
                                    errors={errors}
                                    errorHeader="You've encountered the following error(s):"
                                    innerRef={errorRef} />

                                <FacilityPageHeader
                                    inventoryType={inventoryType}
                                    activities={activities}
                                    isLoading={isLoading}
                                    title={title}
                                    partOf={partOf}
                                    starRating={starRating}
                                    cellRating={cellRating} />

                                {/* Tabs */}
                                <div className="rec-venue-page-tabs-wrap">
                                    <TabItems
                                        stretchTabsToFit
                                        appearance="underline"
                                        tabs={tabs}
                                        activeTabIndex={activeTabIndex}
                                        onActiveTabIndexChange={onActiveTabIndexChange} />
                                </div>
                            </FlexCol>

                            {/* Right Rail */}
                            <FlexCol lg={4}>
                                <RightRail rightRail={rightRail} assetId={assetId}/>
                            </FlexCol>
                        </FlexRow>
                    </ContentContainerBodyShift>

                    {/* Bottom Map */}
                    {map && (
                        <FlexRow hasGutters={false}>
                            <FlexCol className="rec-venue-page-map-wrapper">
                                <div id="map">{map}</div>
                            </FlexCol>
                        </FlexRow>
                    )}
                </div>
            </div>
        );
    }
}
